import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/carpinter-a-a-medida-complete-service-page/page.tsx");
